// components/Pages/Unauthorized/Unauthorized.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => (
    <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: '60vh' }}
    >
        <h2>403 — Access Denied</h2>
        <p className="text-muted">
            You don't have permission to view this page.
        </p>
        <Link className="btn btn-primary mt-2" to="/">
            Back to Home
        </Link>
    </div>
);

export default Unauthorized;